import React from 'react';
import { Logo } from './Logo';
import { useBooking } from './BookingContext';
export function Footer() {
  const {
    openBooking
  } = useBooking();
  return <footer className="bg-[#050505] border-t border-white/5 py-16 relative z-10" data-id="element-257">
      <div className="max-w-7xl mx-auto px-6" data-id="element-258">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-10 mb-16" data-id="element-259">
          <div data-id="element-260">
            <Logo className="text-2xl mb-4" dotClassName="w-2 h-2 ml-1" data-id="element-261" />
            <p className="text-sm text-gray-500 font-medium tracking-wide" data-id="element-262">
              Purpose-built AI for real industries.
            </p>
          </div>

          <div className="flex flex-wrap items-center gap-x-8 gap-y-4" data-id="element-263">
            <a href="#solutions" className="text-sm font-medium text-gray-400 hover:text-white transition-colors" data-id="element-264">
              Solutions
            </a>
            <a href="#platform" className="text-sm font-medium text-gray-400 hover:text-white transition-colors" data-id="element-265">
              Platform
            </a>
            <a href="#solutions" className="text-sm font-medium text-gray-400 hover:text-white transition-colors" data-id="element-266">
              Industries
            </a>
            <a href="#about" className="text-sm font-medium text-gray-400 hover:text-white transition-colors" data-id="element-267">
              About
            </a>
            <a href="#contact" className="text-sm font-medium text-gray-400 hover:text-white transition-colors" data-id="element-268">
              Contact
            </a>
            <button onClick={openBooking} className="text-sm font-medium text-brand-orange hover:text-brand-deep-orange transition-colors" data-id="element-269">
              Book a Demo
            </button>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between pt-8 border-t border-white/5 text-xs text-gray-600" data-id="element-270">
          <div data-id="element-271">
            © {new Date().getFullYear()} Aijentik. All rights reserved.
          </div>
          <div className="flex items-center gap-6 mt-4 md:mt-0" data-id="element-272">
            <a href="#" className="hover:text-gray-400 transition-colors" data-id="element-273">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-gray-400 transition-colors" data-id="element-274">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}